import { render, staticRenderFns } from "./compile.vue?vue&type=template&id=538a4fcf&scoped=true&"
import script from "./compile.vue?vue&type=script&lang=js&"
export * from "./compile.vue?vue&type=script&lang=js&"
import style0 from "./compile.vue?vue&type=style&index=0&id=538a4fcf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538a4fcf",
  null
  
)

export default component.exports